'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Button = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\t\t\tbackground-color: ', ';\n\t\t'], ['\n\t\t\tbackground-color: ', ';\n\t\t']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t\t\ttransform: translateY(-2px);\n\t\t'], ['\n\t\t\ttransform: translateY(-2px);\n\t\t']),
    _templateObject3 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\toutline: none;\n\tcursor: pointer;\n\tborder-radius: 4px;\n\tborder: 1px solid transparent;\n\tcolor: #fff;\n\theight: 40px;\n\tmin-width: 100px;\n\twidth: 100%;\n\tpadding: 0 20px;\n\tfont-size: 16px;\n    white-space: nowrap;\n\tbox-shadow: ', ';\n\tbackground-color: ', ';\n\tfont-family: ', ';\n\ttransition: all 0.15s ease-out;\n\n\t', '\n\n\t&:hover {\n\t\t', '\n\t\tbackground-color: ', ';\n\t}\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\toutline: none;\n\tcursor: pointer;\n\tborder-radius: 4px;\n\tborder: 1px solid transparent;\n\tcolor: #fff;\n\theight: 40px;\n\tmin-width: 100px;\n\twidth: 100%;\n\tpadding: 0 20px;\n\tfont-size: 16px;\n    white-space: nowrap;\n\tbox-shadow: ', ';\n\tbackground-color: ', ';\n\tfont-family: ', ';\n\ttransition: all 0.15s ease-out;\n\n\t', '\n\n\t&:hover {\n\t\t', '\n\t\tbackground-color: ', ';\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _Spinner = require('./Spinner');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = _utils2.default.getColor;


var loadingMixin = function loadingMixin(_ref) {
	var loading = _ref.loading;

	if (loading) {
		return (0, _styledComponents.css)(_templateObject, function (props) {
			return (0, _polished.darken)(0.03, getColor(props, '#ddd'));
		});
	}
};

var fixedMixin = function fixedMixin(_ref2) {
	var fixed = _ref2.fixed,
	    loading = _ref2.loading;

	if (!fixed && !loading) {
		return (0, _styledComponents.css)(_templateObject2);
	}
};

var StyledButton = _styledComponents2.default.button(_templateObject3, _globals2.default.styles.boxShadow, function (props) {
	return getColor(props);
}, _globals2.default.fonts.regular, function (props) {
	return loadingMixin(props);
}, function (props) {
	return fixedMixin(props);
}, function (props) {
	return (0, _polished.darken)(0.03, getColor(props, '#ddd'));
});

var Button = function Button(props) {
	return _react2.default.createElement(
		StyledButton,
		props,
		props.loading ? _react2.default.createElement(_Spinner.Spinner, { xs: true }) : props.children
	);
};

Button.propTypes = {
	loading: _propTypes2.default.bool,
	children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

exports.Button = Button;